import styles from "../../../styles/Components/mini-app/layout/MiniNavbar.module.css";
import { Link, useLocation } from "react-router-dom";
import { FiPieChart } from "react-icons/fi";
import { BsBarChartLineFill } from "react-icons/bs";
import { PiRobot } from "react-icons/pi";
import { FaGear } from "react-icons/fa6";

function MiniNavbar() {
  const { pathname } = useLocation();

  return (
    <ul className={styles.container}>
      <li>
        <Link
          to="/mini-portfolio"
          className={`${styles.navLink} ${pathname === "/mini-portfolio" ? styles.activeLink : ""}`}
        >
          <FiPieChart size={22} />
          <span>Portfolio</span>
        </Link>
      </li>
      <li>
        <Link
          to="/mini-bots"
          className={`${styles.navLink} ${pathname === "/mini-bots" ? styles.activeLink : ""}`}
        >
          <PiRobot size={22} />
          <span>Bots</span>
        </Link>
      </li>
      <li>
        <Link
          to="/mini-ai-signals"
          className={`${styles.navLink} ${pathname === "/mini-ai-signals" ? styles.activeLink : ""}`}
        >
          <BsBarChartLineFill size={22} />
          <span>Signals</span>
        </Link>
      </li>
      <li>
        <Link
          to="/mini-settings"
          className={`${styles.navLink} ${pathname === "/mini-settings" ? styles.activeLink : ""}`}
        >
          <FaGear size={22} />
          <span>Settings</span>
        </Link>
      </li>
    </ul>
  );
}

export default MiniNavbar;
